import { render } from "./VistaCentros.vue?vue&type=template&id=3bbb34e1&scoped=true"
import script from "./VistaCentros.vue?vue&type=script&lang=js"
export * from "./VistaCentros.vue?vue&type=script&lang=js"

import "./VistaCentros.vue?vue&type=style&index=0&id=3bbb34e1&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbb34e1"]])

export default __exports__